import { IonButton, IonIcon, IonText } from "@ionic/react";

interface Props {
  label: string;
  iconLeft?: string;
  iconRight?: string;
  isDisabled?: boolean;
  isDisplayed?: boolean;
  onClick: () => void;
}

const ButtonSlide: React.FC<Props> = ({
  label,
  iconLeft,
  iconRight,
  isDisabled = false,
  isDisplayed = true,
  onClick,
}) => {
  return (
    <>
      {isDisplayed && (
        <IonButton
          shape="round"
          disabled={isDisabled}
          onClick={onClick}
          color="danger"
        >
          {iconLeft && <IonIcon icon={iconLeft} slot="start" size="large" />}
          <IonText color="white">{label}</IonText>
          {iconRight && <IonIcon icon={iconRight} slot="end" size="large" />}
        </IonButton>
      )}
    </>
  );
};

export default ButtonSlide;
